import { useQuery } from '@apollo/client'
import { Survey, WavesQueryVariables } from '../data/gql-gen/dashboard/graphql'
import { useGetProjectByProjectId } from '../modules/Project/Project.hooks'
import { WAVES, WavesData } from '../modules/Project/Project.query'
import { useOptionalWaveId } from './useOptionalWaveId'

/**
 * The surveys the current page works on: inside a tracker wave, that wave's
 * markets, since each wave has its own questionnaire; elsewhere, the project's.
 */
export const useScopedSurveys = (): Survey[] | undefined => {
  const { project } = useGetProjectByProjectId()
  const waveId = useOptionalWaveId()
  const projectId = project?.projectId
  const { data } = useQuery<WavesData, WavesQueryVariables>(WAVES, {
    context: { clientName: 'dashboard' },
    variables: { projectId: projectId ?? '' },
    skip: !waveId || !projectId
  })

  if (!waveId) {
    return project?.surveys
  }

  return data?.waves?.find((wave) => wave.waveId === waveId)?.surveys
}
